import config from 'config';
import useBrowserStorage from 'hooks/useBrowserStorage';
import { useLayoutEffect } from 'react';
import { storageBus } from 'services/storageBus';
import storageKeys from 'services/storageKeys';

export const isMobile = process.env.REACT_APP_BUILD_FOR === 'mobile';
export const isWeb = process.env.REACT_APP_BUILD_FOR !== 'mobile';

export const isTest = ['test'].indexOf(config.env) > -1;
export const isDev = ['local', 'development', 'test'].indexOf(config.env) > -1;
export const isProd = !isDev;

const legacyCopyToClipboard = (text) => {
  return new Promise((resolve, reject) => {
    try {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.top = '0';
      textarea.style.left = '0';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      const successful = document.execCommand('copy');
      document.body.removeChild(textarea);
      if (successful) {
        resolve();
      } else {
        reject(new Error('Copy command was unsuccessful'));
      }
    } catch (error) {
      reject(error);
    }
  });
};

export const copyToClipboard = (text) => {
  if (navigator.clipboard?.writeText) {
    return navigator.clipboard.writeText(text).catch(() => legacyCopyToClipboard(text));
  }

  return legacyCopyToClipboard(text);
};

// Temporary passport helpers
export const isPassportEnabled = () => {
  return JSON.parse(localStorage.getItem(storageKeys.authProvider) || null) === 'passport';
};

export const setAuthProvider = (provider) => {
  return storageBus.write({
    key: storageKeys.authProvider,
    value: provider === 'passport' ? 'passport' : 'legacy',
  });
};

export const useAuthProvider = () => {
  return useBrowserStorage(storageKeys.authProvider, null, null, 'localStorage', true);
};


export const useEnforcedAuthProvider = (provider) => {
  const [current, set] = useAuthProvider();

  useLayoutEffect(() => {
    if (current !== provider) {
      setTimeout(() => set(provider));
    }
  }, [current, provider, set]);
};
